"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.teamTAGPalette = void 0;
var palette_1 = require("../aspendental/palette");
exports.teamTAGPalette = __assign(__assign({}, palette_1.aspendentalPalette), { backgrounds: __assign(__assign({}, palette_1.aspendentalPalette.backgrounds), { dark: '#002953' }) });
